import ApiService from "../api.services";

const IntegrationService = {
  list: async function (customer) {
    try {
      const response = await ApiService.get(
        `/api/integrations?customer=${customer}`
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  },
  get: async function (id) {
    try {
      const response = await ApiService.get(`/api/integrations/${id}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },
  painel: async function () {
    try {
      const response = await ApiService.get(`/api/integrations/painel/list`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },
  painelType: async function (type) {
    try {
      const response = await ApiService.get(
        `/api/integrations/painel/list/${type}`
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  },
  validateCredentials: async function (data) {
    try {
      const response = await ApiService.patch(
        "/api/integrations/credentials/validade",
        data
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  },
  auth2: async function (data) {
    try {
      const response = await ApiService.post("/api/integrations/bling/auth2", data);
      return response.data;
    } catch (error) {
      throw error;
    }
  },
  add: async function (data) {
    try {
      const response = await ApiService.post("/api/integrations", data);
      return response.data;
    } catch (error) {
      throw error;
    }
  },
  update: async function (id, data) {
    try {
      const response = await ApiService.patch(`/api/integrations`, data);
      return response.data;
    } catch (error) {
      throw error;
    }
  },
  status: async function (id) {
    try {
      const response = await ApiService.patch(
        `/api/integrations/${id}/success`
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  },
  execute: async function (id) {
    try {
      const response = await ApiService.post(`/api/integrations/execute/${id}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  delete: async function (id) {
    try {
      const response = await ApiService.delete(`/api/integrations/${id}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  unregister: async function ({ customer, type }) {
    try {
      const response = await ApiService.patch(`/api/integrations/unregister`, {
        customer,
        type,
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  logs: async function (id, records, page) {
    try {
      const response = await ApiService.get(
        `/api/integrations/logs/${id}?records=${records}&page=${page}`
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  },
  logsByTag: async function (id, tag) {
    try {
      const response = await ApiService.get(
        `/api/integrations/logs/${id}/${tag}`
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  },
};

export default IntegrationService;

export { IntegrationService };
